import { render } from "./surcharge_editor.vue?vue&type=template&id=3bb7f169&scoped=true"
import script from "./surcharge_editor.vue?vue&type=script&lang=js"
export * from "./surcharge_editor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb7f169"]])

export default __exports__